module.exports = __webpack_public_path__ + "img/panasoni.e729134a.jpg";